import {IHttpService} from "angular";
import {EquityAccountId} from "../types/EquityAccountRecord";
import {EquityPositionRecords} from "../types/EquityPositionRecord";

export class EquityAccountService {

    public static readonly id = "equityAccountService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async positions(id: EquityAccountId): Promise<EquityPositionRecords> {
        const url = `/tradefloor/api/equity-account/${id}/positions`;
        const response = await this.$http.get<EquityPositionRecords>(url);
        return response.data;
    }
}
